// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZnHe","colMin":"styles_colMin__3Ifo2"};